import { Navbar, Footer } from "./Navbar";
import FloatingChatWidget from "./FloatingChatWidget";
import { DealerCtaStrip } from "./DealerCtaStrip";

export const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Navbar />
      <main className="flex-1 pt-16">
        {children}
      </main>
      <DealerCtaStrip />
      <Footer />
      <FloatingChatWidget />
    </div>
  );
};
